// Party acronym for the tinted logo circle (external logo hosts are CSP-blocked,
// so party cards / seals render initials instead of an <img> logo).
export const partyInitials = (name: string): string =>
	(name ?? '')
		.replace(/[^a-zA-Z0-9]/g, '')
		.slice(0, 4)
		.toUpperCase();
